import { useEffect } from 'react'

const useDocumentTitle = title => {
  useEffect(() => {
    document.title = `${title} - AutoEat`
  })
}

export default useDocumentTitle
